import React, { useState } from 'react';
import { Dropdown, IconButton } from '~/components';
import ProjectTaskCreateForm from '~/routes/app/project-tasks/ProjectTaskCreateForm';
import ProjectTaskTemplatesDrawer from '~/routes/app/project-tasks/ProjectTaskTemplatesDrawer';

export default function NewTaskAction({ project, onSaved }) {
  const [dialog, setDialog] = useState(null);

  const handleAdd = () => {
    setDialog(
      <ProjectTaskCreateForm
        project={project}
        onClose={() => setDialog(null)}
        onSaved={async (data, action) => {
          if (onSaved) await onSaved(data, action);
          if (action === 'save') setDialog(null);
        }}
      />,
    );
  };

  const handleAddFromTemplate = () => {
    setDialog(
      <ProjectTaskTemplatesDrawer
        project={project}
        onClose={() => setDialog(null)}
        onSaved={async (...params) => {
          if (onSaved) await onSaved(...params);
          setDialog(null);
        }}
      />,
    );
  };

  return (
    <>
      <Dropdown align="right">
        {({ setIsOpen }) => (
          <>
            <Dropdown.Trigger>
              <IconButton
                icon="plus"
                onClick={() => setIsOpen(true)}
                disabled={!project.permissions.edit}
                tooltip={
                  project.permissions.edit ? 'New Task' : 'Your security role prohibits you from creating tasks.'
                }
              />
            </Dropdown.Trigger>

            <Dropdown.Menu style={{ width: '15rem' }}>
              <Dropdown.Item onClick={handleAdd}>New Task</Dropdown.Item>
              <Dropdown.Item onClick={handleAddFromTemplate}>Add from Task Template</Dropdown.Item>
            </Dropdown.Menu>
          </>
        )}
      </Dropdown>

      {dialog}
    </>
  );
}
